import { FormGroup } from "@angular/forms";
import { INgxPrimengForm, INgxPrimengFormResult } from "ngx-primeng-form";
import { INgxGridColumn, INgxGridFilter, INgxGridResult } from "ngx-primeng-grid";
import { INgxFilter, INgxResult } from "../../core/_interfaces/iresult";
import { IBreadcrumb } from "../../ngx-wrapper-shared/models/breadcrumb";
import { INgxCrudAction } from "./_crud-manage";

export interface INgxCrudLayout {
    api: INgxCrudLayoutApiConfig;
    setting: INgxCrudLayoutSettingConfig;
    columns: INgxGridColumn[];
    form: INgxCrudLayoutFormConfig;
}

export interface INgxCrudLayoutApiConfig {
    search: string;
    manage: string;
    delete: string;
    changeStatus: string;
    command?: (path: string) => string;
}

export enum NgxCrudLayoutSetting_ManageConfig_Mode {
    modal = 'modal',
    custom = 'custom'
};

export interface INgxCrudLayoutSettingManageActionConfig {
    key: string;
    label: string;
    icon: string;
    styleClass: string;
    mode: NgxCrudLayoutSetting_ManageConfig_Mode;
    modalConfig: {
        title: string;
        width: string;
    }
}

export interface INgxCrudLayoutSettingConfig {
    pageTitle: string;
    actionConfig: {
        enable?: boolean;
        actions: INgxCrudLayoutSettingManageActionConfig[],
        onAction?: (action: INgxCrudLayoutSettingManageActionConfig) => void;
    },
    gridConfig: {
        pk?: string;
        layoutId?: string;
        enableSearch?: boolean;
        sortField?: string;
        sortOrder?: number,
        perPage?: number,
        action?: {
            // store filter instance
            // object will create when grid init
            filter?: INgxFilter<any>;
            // load result
            loadResult?: (callback: (result: INgxGridResult<any>) => void) => void,
            // on filter changed
            onFilterChanged?: (filter: INgxGridFilter) => void,
            // custom action
            customAction: {
                invoke?: (actionName: string, data: any) => void,
                invoked?: (actionName: string, data: any) => void
            }
        },
        breadcrumbs?: IBreadcrumb[]
    }
}

export interface INgxCrudLayoutFormConfig {
    controls: INgxPrimengForm[],
    // this will bind when form prepre completed
    // no need to set
    controlResult?: INgxPrimengFormResult;
    // command
    action: {
        // patch value
        onPatchValue?: (formGroup: FormGroup, formItems: INgxPrimengForm[], data: any) => void,
        // prepare when user want to bind master data
        onPrepareValue?: (formGroup: FormGroup, formItems: INgxPrimengForm[], data: any) => void,
        // call before action perform
        onExecute?: (formValue: any, action: INgxCrudAction, data: any, callback: (result: INgxResult) => void) => void
    },
    actions: INgxCrudAction[]
}

